/**
 * minaki-plp-infinite-scroll.js
 * Stamp: minaki-scroll-fix:20261003a
 *
 * Collection / search infinite scroll: theme IntersectionObserver misses
 * fast mobile flings. The load-more control ends up above the viewport and
 * never loads page 2+, so shoppers feel stuck after the first ~20-24 products.
 *
 * Scroll anchoring is disabled on collection pages: with it on, Chrome pins the
 * footer in view when a new batch is appended above it, the button stays above
 * the viewport, and the "rect.bottom < 80" fling rescue re-fires forever.
 */
(function initMinakiCollectionInfiniteScrollFix() {
  var STAMP = 'minaki-scroll-fix:20261003a';
  if (typeof window !== 'undefined') window.__MINAKI_SCROLL_FIX__ = STAMP;
  var BTN = '[data-load-onscroll]:not([data-is-prev])';
  var lockUntil = 0;
  var lastTriggeredHref = '';
  var scrollTimer = null;
  var pendingChecks = null;

  if (document.querySelector('.t4s-main-collection-page')) {
    document.documentElement.style.overflowAnchor = 'none';
    document.body.style.overflowAnchor = 'none';
  }

  function getButton() {
    return document.querySelector(BTN);
  }

  function triggerLoad() {
    var btn = getButton();
    if (!btn) return false;
    if (btn.classList.contains('is--loading')) return false;
    if (Date.now() < lockUntil) return false;

    var href = btn.getAttribute('href') || '';
    if (!href) return false;

    lastTriggeredHref = href;
    lockUntil = Date.now() + 1100;
    try {
      if (typeof btn.click === 'function') btn.click();
      else btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    } catch (err) {
      lockUntil = 0;
      return false;
    }
    scheduleChecks([200, 600, 1200, 2000]);
    return true;
  }

  function shouldLoad() {
    var btn = getButton();
    if (!btn || btn.classList.contains('is--loading')) return false;

    var rect = btn.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (vh < 1) return false;

    var lead = Math.max(Math.round(vh * 0.9), 560);
    if (rect.bottom < 80) return true;
    if (rect.top < vh + lead) return true;
    return false;
  }

  function check() {
    if (shouldLoad()) triggerLoad();
  }

  function scheduleChecks(delays) {
    if (pendingChecks) {
      pendingChecks.forEach(function (id) {
        window.clearTimeout(id);
      });
    }
    pendingChecks = (delays || [0]).map(function (ms) {
      return window.setTimeout(check, ms);
    });
  }

  function onScroll() {
    if (scrollTimer) return;
    scrollTimer = window.setTimeout(function () {
      scrollTimer = null;
      check();
    }, 50);
  }

  function onScrollSettled() {
    scheduleChecks([40, 200, 450]);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('touchend', onScrollSettled, { passive: true });
  window.addEventListener('resize', onScrollSettled, { passive: true });

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            triggerLoad();
            break;
          }
        }
      },
      { root: null, rootMargin: '80% 0px 80% 0px', threshold: 0 }
    );

    function observeButton() {
      var btn = getButton();
      if (!btn) return;
      if (btn.getAttribute('data-minaki-lm-io') === '1') return;
      btn.setAttribute('data-minaki-lm-io', '1');
      io.observe(btn);
    }

    observeButton();

    var main =
      document.querySelector('.t4s-main-collection-page') ||
      document.querySelector('[data-ntajax-container]');
    if (main && window.MutationObserver) {
      new MutationObserver(function () {
        var btn = getButton();
        if (btn && btn.getAttribute('href') !== lastTriggeredHref) {
          lockUntil = 0;
        }
        observeButton();
        scheduleChecks([100, 350, 800]);
      }).observe(main, { childList: true, subtree: true });
    }
  }

  scheduleChecks([400, 1000]);
  document.addEventListener('facet:updated', function () {
    lockUntil = 0;
    scheduleChecks([150, 400, 900]);
  });
  document.addEventListener('shopify:section:load', function () {
    lockUntil = 0;
    scheduleChecks([150, 400, 900]);
  });
})();
